class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.button &&
      this.button.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    const quickAddModal = document.querySelector("quick-add-modal");
    quickAddModal && quickAddModal.show(this.dataset.url);
  }
}
customElements.define("quick-add-button", QuickAddButton);
